import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { SiCsharp, SiDotnet } from 'react-icons/si';
import { topicsIndex } from '../../data/topicsIndex';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const [expandedLanguages, setExpandedLanguages] = useState(['csharp']);
  const [expandedCategories, setExpandedCategories] = useState({});

  const toggleLanguage = (langId) => {
    setExpandedLanguages(prev => 
      prev.includes(langId) 
        ? prev.filter(id => id !== langId)
        : [...prev, langId]
    );
  };

  const toggleCategory = (categoryId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const getLanguageIcon = (langId) => {
    switch(langId) {
      case 'csharp': return <SiCsharp />;
      case 'dotnet': return <SiDotnet />;
      default: return <FiChevronRight />;
    }
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-content">
        <div className="sidebar-section">
          <h3>Learning Path</h3>
          
          {topicsIndex.map(language => (
            <div key={language.id} className="language-group">
              <div 
                className="language-header"
                onClick={() => toggleLanguage(language.id)}
              >
                <span className="language-icon">{getLanguageIcon(language.id)}</span>
                <span style={{ flex: 1 }}>{language.name}</span>
                {expandedLanguages.includes(language.id) ? <FiChevronDown /> : <FiChevronRight />}
              </div>
              
              {expandedLanguages.includes(language.id) && (
                <div className="category-list">
                  {language.categories.map(category => (
                    <div key={category.id} className="category-item">
                      <div 
                        className="category-header"
                        onClick={() => toggleCategory(`${language.id}-${category.id}`)}
                      >
                        <span>{category.name}</span>
                        {expandedCategories[`${language.id}-${category.id}`] ? <FiChevronDown /> : <FiChevronRight />}
                      </div>
                      
                      {expandedCategories[`${language.id}-${category.id}`] && (
                        <div className="topic-list">
                          {category.topics.map(topic => (
                            <Link
                              key={topic.id}
                              to={`/topic/${language.id}/${category.id}/${topic.id}`}
                              className={`topic-link ${
                                location.pathname === `/topic/${language.id}/${category.id}/${topic.id}` 
                                  ? 'active' 
                                  : ''
                              }`}
                              onClick={onClose} // Close sidebar when topic is clicked on mobile
                            >
                              {topic.title}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;

